export const DOLPHIN_API = {
  CLIENT_MANAGEMENT: '/api/organizations/client_management',
  ORGANIZATION_INFO: '/api/organizations/organization_info',
  ORGANIZATION_PREFERENCE: '/api/organizations/organization_preference',
  ORGANIZATION_NEW: '/api/organizations/new',
  TEMPLATE_MANAGEMENT: '/api/organizations/template_management',
  USER_MANAGEMENT: '/api/organizations/user_management',
  TODOS: '/api/organizations/todos',
  PROJECT: '/api/organizations/project',
  PERSONAL_INFO: '/api/user/personal_info',
  ISSUES_RECEIVED: '/api/issues/received',
  ISSUES_SENT: '/api/issues/sent',
  USERS: '/api/user',
  LOGS: '/api/logs',
  ISSUES: '/api/issues',
  USERS_IN_ORGANIZATION: '/api/organizations/users',
  ISSUES_BATCH_UPDATE: '/api/issues/batch-update',
  ISSUE_SEQUENCE_PREVIOUS_ISSUE_ID: '/api/issue-sequence/previous-issue-id',
  COMMENTS: '/api/comments',
  ATTACHMENT: '/api/attachment',
  DOWNLOAD: '/api/download',
  TEMPLATES: '/api/templates',
  NOTIFICATIONS: '/fugu/notifications',
  NOTIFICATION_PREFERENCE: '/fugu/preference',
  NOTIFICATION_PREFERENCE_ALL: '/fugu/preference/all',
  NARWHAL_ANALYSIS: '/narwhal/llm-analytics/issue/analysis',
  NARWHAL_PROMPTS: '/narwhal/prompts',
  NARWHAL_PROMPTS_RESTORE_DEFAULT: '/narwhal/prompts/restore-default',
  NARWHAL_PARSED_TEXT_ISSUE_INFO: '/narwhal/iwg-admin/issue-info',
  NARWHAL_PARSED_TEXT_ATTACHMENT_CONTENT_ONLY:
    '/narwhal/iwg-admin/parsed-text/attachment/content-only',
  ADMIN_CONTRACTS: '/api/admin/contracts',
  ADMIN_ORGS: '/api/admin/orgs',
  ADMIN_EMPLOYMENTS: '/api/admin/employments',
  ADMIN_USERS: '/api/admin/users',
  ADMIN_ISSUES: '/api/admin/issues',
  ADMIN_FILL_DATA: '/api/admin/fillData',
  ADMIN_REPORT_TEMPLATES: '/api/admin/templates',
  ADMIN_FILL_EMPLOYMENT_USER_TYPE: '/api/admin/fillEmploymentUserType',
  ADMIN_TAGS: '/api/admin/tags',
  USER_SERVICE: '/api/user/service-terms',

  EMPLOYMENT_PRIVILEGE: '/api/employments/privilege',
  REPORTS: '/api/reports',
  PAID_WAGE: '/api/wages/paid',
  MY_WAGE: '/api/wages/my',
  BILLS_RECEIVED_TASKS: '/api/bills/received',
  BILLS_SENT_TASKS: '/api/bills/sent',
  TAGS: '/api/tags',
  TRY_CREATE_BILL: '/api/triggers/tryCreateBill',
  SEARCH: '/api/search',
  LLM_ANALYTICS: '/api/llm-analytics/issue/analysis',
  LLM_ANALYTICS_STATUS: '/api/llm-analytics/issue/analysis/status',
};

export const KENSHIN_API = {
  ASSIGNMENT_RECEIVED: '/kenshinApi/assignments/received',
  ADD_DIAGNOSIS: '/kenshinApi/assignments/add-diagnosis',
  ISSUES: '/kenshinApi/issues',
  ISSUES_RECEIVED: '/kenshinApi/issues/received',
  ISSUES_SENT: '/kenshinApi/issues/sent',
  ISSUES_BATCH_UPDATE: '/kenshinApi/issues/batch-update',
  ATTACHMENT: '/kenshinApi/attachment',
  PROJECT: '/kenshinApi/organizations/project',
  CASES_BATCH_UPDATE: '/kenshinApi/cases/batch-update',
  BILLS_RECEIVED_ISSUES: '/kenshinApi/bills/receivedIssues',
  BILLS_SENT_ISSSUES: '/kenshinApi/bills/sentIssues',
  PAID_WAGE: '/kenshinApi/wages/paid',
  MY_WAGE: '/kenshinApi/wages/my',
  DEV: '/kenshinApi/dev',
};

export const LOGOUT_URL = 'https://demo.docloud.iwg-inc.co.jp/';
